<template>
  <div class="bg" :class="{ 'auth-screen': !eSignAuthentication, 'white-bg': isTestPortalFeatureEnabled }">
    <div class="row">
      <div class="col-xs-12 col-md-12 col-lg-12 col-sm-12 text-center">
        <div v-if="eSignAuthentication && eSignAuthentication == true" class="p-50">
          <div v-if="eAuthSuccess">
            <div class="text-center mb-15">
              <img src="static/img/resource-module-green-check.png" alt="" class="green-pop-check" />
            </div>
            <h4>
              Success! Now you can finalize the signing process by going back to your application portal.
            </h4>
            <!--<div class="note mt-15">Now you can proceed with the signing process by going back to your application portal.</div>-->
          </div>
          <div v-else>
            <h4 class="text-danger">
              The authentication and signature process was not completed. Please proceed back to your application portal.
            </h4>
            <!--<div class="note mt-15">{{errorMsg}}</div>-->
          </div>
          <div class="mt-20">
            <button type="button" class="btn btn-primary" @click="closeTab">
              Close
            </button>
          </div>
        </div>
        <p v-else-if="errorMsg" class="fs-24 text-center color_ff mt-120" dir="auto">
          {{ errorMsg }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// this is needed for an edge case where moving from the sso idp to the vue app does not load the feature flag to vue state fast enough
import { isTestPortalEnabled } from "@/utils/featureFlag";

export default {
  name: "ssologin",
  data() {
    return {
      errorMsg: null,
      eSignAuthentication: null,
      eAuthSuccess: null
    };
  },
  computed: {
    ...mapGetters(["user", "ssoLoginURL"]),
    isTestPortalFeatureEnabled() {
      return isTestPortalEnabled();
    }
  },
  watch: {
    user(user) {
      if (user.id) {
        this.redirect();
      }
    }
  },
  methods: {
    ...mapActions(["sessionExpiredLogoutUser", "SSOLogin"]),
    getCognitoAccessToken(authCode) {
      this.$api.getCognitoAccessTokenFromSSOCode(authCode).then(
        async response => {
          try {
            await this.SSOLogin(response.body.data.id_token);
          } catch (error) {
            this.errorMsg = error.message ? error.message : error;
          }
        },
        error => {
          this.errorMsg = error.body && error.body.message ? error.body.message : "Error while getting access token!";
        }
      );
    },
    redirect() {
      if (!this.user.onBoarding) {
        if (this.user.profileCompleted === true && this.user.otpVerified) {
          if (this.user.userRole === "SystemAdmin") {
            this.routeTo("invite-admins");
          } else {
            this.routeTo("studies");
          }
        } else {
          this.routeTo("aboutYou", {
            userId: this.user.id
          });
        }
      } else {
        this.routeTo("studies");
      }
      this.$toastr.success("Successfully logged in");
    },
    routeTo(routeNameOld, pathParamsOld = null) {
      let routeName = routeNameOld;
      let pathParams = pathParamsOld;

      if (routeName == "studies") {
        if (this.isTestPortalFeatureEnabled) {
          window.location.href = "/studies-list/";
          return;
        }

        if (this.user.userSite && this.user.userSite.length == 1 && this.user.userSite[0].status.toLowerCase() == "active") {
          routeName = "dashboard";
          pathParams = { studyId: this.user.userSite[0].studyId };
        }
      }
      const routeObj = this.$router.resolve({
        name: routeName
      });
      if (pathParams) {
        let redirectRoute = routeObj.href + routeObj.route.matched[0].path.substring(1);
        for (const property in pathParams) {
          redirectRoute = redirectRoute.replace(`:${property}`, `${pathParams[property]}`);
        }
        window.location.href = window.location.origin + redirectRoute;
      } else {
        window.location.href = window.location.origin + "/" + routeObj.href;
      }
    },
    closeTab() {
      window.close();
    }
  },
  async mounted() {
    const qd = {};
    location.search
      .substr(1)
      .split("&")
      .forEach(function(item) {
        const k = item.split("=")[0];

        const v = decodeURIComponent(item.split("=")[1]);
        k in qd ? qd[k].push(v) : (qd[k] = [v]);
      });

    //**************Send data to parent window that initiated signicat authentication starts here ******
    if (qd.state && qd.state[0].indexOf("signicatAuthentication") !== -1) {
      this.eSignAuthentication = true;
      if (qd.code && qd.code[0] != "") {
        this.eAuthSuccess = true;
        this.errorMsg = "Authentication Successfull";
      } else {
        this.eAuthSuccess = false;
      }
    }
    //**************Send data to parent window that initiated signicat authentication ends here******
    else if (qd.code && qd.code[0] != "") {
      this.$store.commit("SHOW_LOADER", true);
      this.sessionExpiredLogoutUser().then(async () => {
        this.getCognitoAccessToken(qd.code[0]);
      });
    } else if (qd.error_description && qd.error_description[0] != "") {
      if (qd.error_description[0].includes("Already+found+an+entry+for+username")) {
        window.location.href = this.ssoLoginURL;
      } else {
        let errMsg = qd.error_description[0].split("###");
        errMsg = errMsg.length > 1 ? errMsg[2].trim() : errMsg[0];
        this.errorMsg = errMsg.replace(/\+/g, " ");
      }
    } else {
      this.$router.push({
        name: "login",
        query: { redirectTo: this.$route.query.redirectTo }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.green-pop-check {
  width: 70px;
  height: auto;
  object-fit: contain;
}
h5 {
  color: #34537d;
}
.note {
  color: #666669;
  opacity: 0.7;
}
</style>
<style lang="scss" src="@/assets/auth-screen.scss"></style>
